import React from "react";
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Paper,
  Button,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { STATUS_OPTIONS } from "../../constants/status";
import { TYPE_OPTIONS } from "../../constants/agreementType";
import dayjs from "dayjs";

const AgreementFilters = ({
  searchQuery,
  onSearchChange,
  statusFilter,
  onStatusChange,
  subscriptionFrom,
  onSubscriptionFromChange,
  subscriptionTo,
  onSubscriptionToChange,
  validityFrom,
  onValidityFromChange,
  validityTo,
  onValidityToChange,
  typeFilter,
  onTypeChange,
  onClearFilters,
  statusOptions,
}) => {
  return (
    <Box component={Paper} sx={{ p: 2, mb: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Buscar por n° de orden, objetivo o institución"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            size="small"
            fullWidth
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth size="small">
            <InputLabel>Estado</InputLabel>
            <Select
              value={statusFilter}
              onChange={(e) => onStatusChange(e.target.value)}
            >
              {statusOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth size="small">
            <InputLabel>Tipo de convenio</InputLabel>
            <Select
              value={typeFilter}
              onChange={(e) => onTypeChange(e.target.value)}
              label="Selecciona el tipo"
            >
              {TYPE_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <DatePicker
            label="Desde (Suscripción)"
            value={subscriptionFrom  ? dayjs(subscriptionFrom) : null}
            onChange={onSubscriptionFromChange}
            format="DD/MM/YYYY"
            slotProps={{ textField: { size: "small", fullWidth: true } }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <DatePicker
            label="Hasta (Suscripción)"
            value={subscriptionTo ? dayjs(subscriptionTo) : null}
            onChange={onSubscriptionToChange}
            format="DD/MM/YYYY"
            slotProps={{ textField: { size: "small", fullWidth: true } }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <DatePicker
            label="Desde (Vigencia)"
            value={validityFrom ? dayjs(validityFrom) : null}
            onChange={onValidityFromChange}
            format="DD/MM/YYYY"
            slotProps={{ textField: { size: "small", fullWidth: true } }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <DatePicker
            label="Hasta (Vigencia)"
            value={validityTo ? dayjs(validityTo) : null}
            onChange={onValidityToChange}
            format="DD/MM/YYYY"
            slotProps={{ textField: { size: "small", fullWidth: true } }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Button
            variant="outlined"
            color="secondary"
            fullWidth
            onClick={onClearFilters}
          >
            Limpiar filtros
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AgreementFilters;
